import { enCalendarInvite } from "./enCalendarInvite";
import { enCampaignTestBanner } from "./enCampaignTestBanner";
import { enCopywritingSettings } from "./enCopywritingSettings";
import { enCampaignBuilder } from "./enCampaignBuilder";
import { enCsvEnrichment } from "./enCsvEnrichment";
import { enAdminFixes } from "./enAdminFixes";
import { enCron } from "./enCron";
import { enApiHealth } from "./enApiHealth";
import { enCookie } from "./enCookie";
import { enWebhookHealth } from "./enWebhookHealth";
import { enWebhookLists } from "./enWebhookLists";
import { enWebhookSigning } from "./enWebhookSigning";
import { enLiProfileVisits } from "./enLiProfileVisits";
import { enRequests } from "./enRequests";
import { enLeadScoring } from "./enLeadScoring";
import { enMcpConsent } from "./enMcpConsent";
import { enErrors } from "./enErrors";
import { enSetPassword } from "./enSetPassword";
import { enForgotPassword } from "./enForgotPassword";
import { enVerifyEmail } from "./enVerifyEmail";
import { enErrorPages } from "./enErrorPages";
import { enArchivedAccount } from "./enArchivedAccount";
import { enTopupCredits } from "./enTopupCredits";
import { enCreditConfirm } from "./enCreditConfirm";
import { enModals } from "./enModals";
import { enCompanyEnrich } from "./enCompanyEnrich";
import { enOnboarding, enRegister } from "./enOnboarding";
import { enOnboardingTour } from "./enOnboardingTour";
import { enProfileTracker } from "./enProfileTracker";
import { enCampaignsOverview } from "./enCampaignsOverview";
import { enCampaignLockExplainer } from "./enCampaignLockExplainer";
import { enOutreachActivation } from "./enOutreachActivation";
import { enUserRoles } from "./enUserRoles";
import { enContacts } from "./enContacts";
import { enListSettingsPrices } from "./listSettingsPrices";
import { enFeed } from "./enFeed";
import { enTwoFA } from "./enTwoFA";
import { enLiCompanyActivity } from "./enLiCompanyActivity";
import { enLiProfile } from "./enLiProfile";
import { enOpenAi } from "./enOpenAi";
import { enApiKey } from "./enApiKey";
import { enProspectSearch } from "./enProspectSearch";
import { enCopywritingFrameworks } from "./enCopywritingFrameworks";
import { enDefineIcps } from "./enDefineIcps";
import { enListSignals } from "./enListSignals";
import { enInbox } from "./enInbox";
import { enOutbox } from "./enOutbox";
import { enCrmAddTo, enCrmAddToBasics } from "./enCrmAddTo";
import { enCrmProviders } from "./enCrmProviders";
import { enListCrmSettings } from "./enListCrmSettings";
import { enListDetailsStep } from "./enListDetailsStep";
import { enReachOut } from "./enReachOut";
import { enListSourceFilter } from "./enListSourceFilter";
import { enListCampaignBulk } from "./enListCampaignBulk";
import { enListCampaignMetrics, enListCampaignRollup } from "./enListCampaignRollup";
import { enListNoFile, enListRerun } from "./enListRunControls";
import { enListSources } from "./enListSources";
import { enSubscriptionCheckout } from "./enSubscriptionCheckout";
import { enSubscriptionOverview } from "./enSubscriptionOverview";
import { enIntegrations } from "./enIntegrations";
import { enAnalytics } from "./enAnalytics";
import { enHelpCenter } from "./enHelpCenter";
import { enFeatureUsageTranslations } from "./enFeatureUsage";
import { enSupportDashboard } from "./enSupportDashboard";
import { enPendingSchedules } from "./enPendingSchedules";
import { enLogin } from "./enLogin";
import { enGenerateBar } from "./enGenerateBar";
import { enBlacklist } from "./enBlacklist";
import { enCustomEvent } from "./enCustomEvent";
import { enListScopeFilter } from "./enListScopeFilter";
import { enOutreach } from "./enOutreach";
import { enAccount } from "./enAccount";
import { enNotificationPreferences } from "./enNotificationPreferences";
import { enInviteUser } from "./enInviteUser";
import { enCompanies } from "./enCompanies";
import { enUsers } from "./enUsers";
import { enLiSn } from "./enLiSn";
import { enSupport } from "./enSupport";

export default {
	translation: {
		linkedin: {
			tier: {
				free: "LinkedIn Free",
				premium: "LinkedIn Premium",
				salesNavigator: "LinkedIn Sales Navigator",
				freeWarning:
					"LinkedIn Free accounts can only send about 5 connection requests with a note per month.",
			},
		},
		templates: {
			title: "Templates",
			tabs: {
				prompts: "Prompts",
				replies: "Replies",
				deepResearchPrompts: "Deep Research Prompts",
			},
			prompts: {
				name: "Name",
				prompt: "Prompt",
				type: "Type",
				category: "Category",
				createdBy: "Created by",
				lastModifiedBy: "Last modified by",
			},
			replies: {
				name: "Name",
				message: "Reply",
				createdBy: "Created by",
				lastModifiedBy: "Last modified by",
			},
			deepResearchPrompts: {
				name: "Name",
				sections: "Sections",
				language: "Language",
				outputLanguage: "Output Language",
				createdAt: "Created at",
			},
		},
		variables: {
			section: {
				title: "Variables",
				inUse: "{{count}} in use",
				searchPlaceholder: "Search variables…",
				insert: "Insert",
				inMessage: "In message",
				emptySearch: "No variables found",
			},
			eventSection: {
				title: "Event Variables",
				searchPlaceholder: "Search event variables…",
				emptySearch: "No event variables found",
			},
		},
		editorFooter: {
			variable: "Variable",
			spintax: "Spintax",
			aiSnippet: "AI snippet",
			templates: "Templates",
			typeHint: "Type { to insert variables",
			newSpintax: "New spintax…",
			newAiSnippet: "New AI snippet…",
			searchTemplates: "Search templates…",
			emptyTemplates: "No templates found",
			sections: {
				lead: "Lead",
				event: "Event",
				sender: "Sender",
				available: "Available",
				create: "Create",
				templates: "Templates · insert at cursor",
			},
		},
		spintax: {
			section: {
				title: "Spintax",
				inUse: "{{count}} in use",
				searchPlaceholder: "Search spintax…",
				insert: "Insert",
				inMessage: "In message",
				variations_one: "{{count}} variation",
				variations_other: "{{count}} variations",
				configure: "Configure",
				emptySearch: "No spintax found",
				createNew: "Create new",
			},
		},
		aiSnippet: {
			tabs: {
				prompt: "Prompt",
				systemPrompt: "System Prompt",
			},
			section: {
				title: "AI Snippets",
				inUse: "{{count}} in use",
				searchPlaceholder: "Search AI snippets…",
				insert: "Insert",
				inMessage: "In message",
				template: "Template",
				configure: "Configure",
				emptySearch: "No snippets found",
				createNew: "Create new",
				testForLead: "Test AI Snippets for {{name}}",
				testHint:
					"Testing is free — results are not saved. Select a lead on the left panel to test for a different lead.",
				testIntro:
					"To improve the quality of the AI snippet and testing the AI snippet, please first write the full message as intended and then fine-tune the AI snippet, because we add the full message as context to the AI snippet agent.",
			},
			modal: {
				title: "AI Snippets",
				subtitle: "Browse, edit and create AI-filled placeholders for your messages",
				close: "Close",
				library: "Your library",
				searchPlaceholder: "Search snippets...",
				insertedInThisMessage: "Inserted in this message",
				createNew: "Create new AI snippet",
				untitled: "Untitled snippet",
				unsaved: "Unsaved",
				emptyState: {
					title: "No AI snippets yet",
					hint: "Click below to create your first snippet.",
				},
				name: {
					label: "AI Snippet name",
					helper: "Used as {name} in your message",
					placeholder: "e.g. pain point",
					duplicate: "An AI snippet with this name already exists in this list.",
					invalid: "Snippet names cannot contain { } or |.",
				},
				prompt: {
					label: "Instructions for the AI agent",
					helper: "What should the AI write here, per lead?",
					hint: "Type {{'{'}} to insert variables",
					charCount: "{{count}} characters",
				},
				responseType: {
					title: "Response type",
					best: {
						label: "Best response",
						helper:
							"AI writes free-form output based on your instructions. Best for openers, transitions, value props.",
					},
					schema: {
						label: "One of these values",
						helper:
							"AI picks the best match from your fixed list. Best for industry, segment, tier labels.",
						addValue: "Add value",
						valuePlaceholder: "Enter a value...",
						removeValue: "Remove value",
					},
				},
				fewShot: {
					title: "Few-shot examples",
					optional: "Optional",
					counter: "{{count}} of {{max}}",
					subtitle:
						"Show the AI what good output looks like. Each pair: an example lead context, and the ideal output for it. Strongest lever for quality.",
					exampleNum: "Example {{index}}",
					leadContextLabel: "Example instructions",
					leadContextPlaceholder:
						'The instructions for the AI agent with variables resolved for this lead. Click "Pre-fill from available leads" to auto-populate.',
					idealOutputLabel: "Ideal output",
					idealOutputPlaceholder: "What should the AI write for this lead?",
					addExample: "Add example",
					removeExample: "Remove example",
					prefillFromLeads: "Pre-fill from available leads",
				},
				testExplainer: {
					trigger: "How to test this snippet",
					title: "Testing AI snippets",
					body: "Snippets can't be tested in isolation — the AI agent needs the surrounding message to ensure grammatical fit. Insert this snippet into your message, then click Test message in the right panel to preview on any lead.",
				},
				footer: {
					cancel: "Cancel",
					discardChanges: "Discard changes",
					saveAsNew: "Save as new snippet",
					update: "Update snippet",
					insertExisting: "Insert snippet",
					insertEphemeral: "Insert AI snippet",
					saveAsTemplateAndInsert: "Save as template & insert",
					insertEphemeralHint: "The AI snippet will not be saved as a template",
					unsavedChanges: "Discard unsaved changes?",
					unsavedChangesBody:
						"You have unsaved edits to this snippet. Closing now will discard them.",
					unsavedChangesConfirm: "Discard",
				},
				deleteConfirm: {
					title: "Delete AI Snippet",
					body: "Are you sure you want to delete this AI snippet?",
					warning:
						"If you are using this snippet anywhere else, the message generation will stop working.",
					confirm: "Delete",
				},
			},
			testModal: {
				title: "Test message",
				generatingHint: "Generating… this is free and results are not saved.",
				resultHint: "Test message — free, not saved to the campaign.",
				generatedLabel: "Generated message",
				steps: {
					composing: "Composing prompt from message body & instructions",
					resolvingVariables: "Resolving variables for this lead",
					aiWriting: "AI agent writing snippet from Deep Research & signals",
					assembling: "Assembling full message",
				},
				legend:
					"Highlighted in yellow are AI snippets, generated live for this lead. Variables resolved from lead data are shown in blue.",
				regenerate: "Regenerate",
				done: "Done",
				close: "Close",
				error: "Something went wrong while generating the test message.",
				retry: "Retry",
			},
		},
		integrations: enIntegrations,
		swarm: {
			namePlaceholder: "e.g. CEOs of Digital Agencies in Germany",
			nameLabel: "Name",
			sourceNameLabel: "Source Name",
			jobTitlesLabel: "Job Titles",
			jobTitlesPlaceholder: "e.g. CEO, CTO, CFO",
			excludeJobTitlesLabel: "Exclude Job Titles",
			excludeJobTitlesPlaceholder: "e.g. Junior Marketing Manager, Intern",
			jobLevelsLabel: "Job Levels",
			jobLevelsPlaceholder: "e.g. CEO, CTO, CFO",
			countriesLabel: "Personal Location (Country Region City)",
			countriesPlaceholder: "e.g. Germany North Rhine Westphalia",
			citiesLabel: "Cities",
			citiesPlaceholder: "e.g. Berlin",
			statesLabel: "States",
			statesPlaceholder: "e.g. Berlin",
			companyNamesLabel: "Company Names",
			companyNamesPlaceholder: "e.g. Google",
			excludeCompanyNamesLabel: "Exclude Company Names",
			allowExcludeCompanyNamesLabel: "Allow Exclude Company Names",
			excludeCompanyNamesPlaceholder: "e.g. Google",
			companySizesLabel: "Company Sizes",
			companySizesPlaceholder: "e.g. 100",
			companyIndustriesLabel: "Company Industries",
			companyIndustriesPlaceholder: "e.g. Software",
			companyWebsitesLabel: "Company Websites",
			companyWebsitesPlaceholder: "e.g. https://www.google.com",
			companyCountriesLabel: "Company HQ Location (Country Region City)",
			companyCountriesPlaceholder: "e.g. Germany North Rhine Westphalia",
			companyStatesLabel: "Company States",
			companyStatesPlaceholder: "e.g. Berlin",
			companyCitiesLabel: "Company Cities",
			companyCitiesPlaceholder: "e.g. Berlin",
			schoolNamesLabel: "School Names",
			schoolNamesPlaceholder: "e.g. Harvard University",
			pastEmployersLabel: "Past Employers",
			pastEmployersPlaceholder: "e.g. Google",
			yearsInCurrentRoleLabel: "Years in Current Role",
			yearsInCurrentRolePlaceholder: "e.g. 10",
			yearsInCurrentRoleInformation:
				"We will search for people who have been in the current role for the selected number of years.",
		},
		fundingMa: {
			namePlaceholder: "e.g. Seed Rounds in Germany last 30 days",
			amountPlaceholder: "e.g. 1000000",
			roundPlaceholder: "e.g. Series A",
			dateFromPlaceholder: "e.g. 2024-01-01",
			dateToPlaceholder: "e.g. 2025-12-31",
			lastXDaysPlaceholder: "e.g. 180 days",
			nameLabel: "Name",
			amountLabel: "Amount",
			amountInformation: "Enter the amount of the funding in USD",
			maAmountLabel: "Amount",
			maAmountInformation: "Amount the acquiring company paid for the acquisition.",
			roundLabel: "Funding Round",
			roundInformation: "Select the round type of the funding",
			dateFromLabel: "From Date",
			dateToLabel: "To Date",
			dateFromInformation: "We will search for activities between the selected dates.",
			dateToInformation: "We will search for activities between the selected dates.",
			lastXDaysLabel: "Last X Days",
			lastXDaysInformation: "We will search for activities in the last X days.",
			countriesLabel: "Company HQ",
			countriesInformation: "Select the countries where the startup is located",
			categoryLabel: "Company Industry",
			categoryInformation: "Select the industries where the startup is located",
			countriesPlaceholder: "e.g. Germany",
			categoryPlaceholder: "e.g. Software",
			maStatusLabel: "Deal Status",
			maStatusInformation: "Deal status (e.g., announced, completed, pending)",
			maStatusPlaceholder: "e.g. Announced or Completed",
		},
		messages: {
			pageTitle: {
				review: "Review to send",
				inbox: "Inbox",
				outbox: "Outbox",
			},
			/** PREC-2523: an empty leads column caused by a search or a filter, not by an empty surface. */
			noResultsFound: "No results found",
			ignoreLead: "Are you sure you want to ignore this lead?",
			noContactYet: "No contact yet",
			findLeads: "Find leads",
			configureSenders: "You can configure who is sending this sequence.",
			defineSender: "Defining who is sending this sequence",
			checkLeadLater: "Do you really want to review this lead later?",
			checkLater: "Review later",

			moreThanOneSender:
				"When you select more than one sender, the sender will be selected based by random.",
			scheduleSequence: "Are you sure you want to schedule this sequence?",
			priorityNotCalculated: "Priority not calculated",
			unknown: "Unknown",
			generatingDrafts: "Generating drafts…",
			preAssignedToCampaign: "Pre-assigned to {{name}}",
			notYetPreAssigned: "Not yet pre-assigned to a campaign",
			chatDraftsReady: "Chat drafts ready",
			crmSyncLabel: "Sync",
			crmSyncContactRecords: "Contact records",
			crmSyncCompanyRecords: "Company records",
			assignToCampaign: "Assign to campaign",
			assignToCampaignSubtitle:
				"Choose a campaign. Pre-assign to stage it, or assign & send out to activate now.",
			chooseCampaign: "Choose a campaign",
			onlyPreAssign: "Only pre-assign",
			assignAndSendOut: "Assign & send out",
			noOutreachYetTitle: "No outreach yet",
			signpostNoOutreachDesc:
				"Reach out individually in Chat, or put this lead on a structured sequence by assigning a campaign.",
			signpostDraftsDesc:
				"This lead has drafts waiting in Chat. Review and send them, or put the lead on a structured campaign instead.",
			reachOut: "Reach out",
			reviewDrafts: "Review drafts",
			createCampaign: "Create campaign",
			outboxNoCampaignTitle: "Not on a campaign",
			outboxNoCampaignDesc:
				"This lead got or will get their messages individually via Chat — not through a structured campaign sequence.",
			openChat: "Open chat",
			confirmAndSend: "Confirm & send",
			discardChatDraftsTitle: "Discard Chat drafts?",
			discardChatDraftsBody:
				"This lead has Chat drafts ready. Pre-assigning a campaign will use the campaign sequence instead, and the Chat drafts will no longer be shown.",
			keepDrafts: "Keep drafts",
			discardAndContinue: "Discard & continue",
			stopSendingAfterDate: "Stop sending after date",
			stopSendingAfterDateSubtitle:
				"Stop time-sensitive follow-ups from firing after this date for this lead.",
			stopSendingAfter: "Stop sending after",
			stopsAfter: "Stops after",
			removeCutoff: "Remove cutoff",
			selectDate: "Select date",
			aiSnippetPending: "AI snippets not generated yet",
			aiSnippetGenerating: "Generating AI snippets…",
			aiSnippetReady: "AI snippets ready",
			deepResearchPending: "Deep research not run yet",
			deepResearchRunning: "Deep research running…",
			deepResearchReady: "Deep research done",
			noSendingUsers: "No sending users",
			compose: {
				title: "Compose",
				linkedin: "Search with name on linkedin",
				linkedinUrl: "Use a linkedin url",
				nameAndCompanyName: "Search with name and company name",
				email: "Search with email",
				enterManually: "Enter manually",
			},
			tabs: {
				chat: "Chat",
				campaign: "Campaign",
			},
			messagesAssignStatus: {
				UNSCHEDULED: "Not Scheduled",
				SCHEDULED: "Scheduled",
				RUNNING: "Running",
				SAVED_FOR_LATER: "Saved for later",
				REPLIES: "Replies",
				ENDED: "Ended",
				PAUSED: "Paused",
			},
			title: {
				"ready-to-send": "Review to send",
				inbox: "Inbox",
				outbox: "Outbox",
				followUp: "Follow Up",
			},
			filter: "Filter",
			languageAutoDetectRules: {
				title: "Language auto-detect rules",
				subtitle: "Rules are evaluated top to bottom — first match wins",
				addRule: "+ Add rule",
				addCondition: "+ condition",
				removeRule: "Remove rule",
				removeCondition: "Remove condition",
				orConnector: "— OR —",
				thenPick: "THEN PICK",
				elseLabel: "No rule matched — pick default language:",
				defaultLanguagePlaceholder: "Select default language...",
				selectCountries: "Select countries...",
				failedToSave: "Failed to save rules",
				save: "Save rules",
				operator: {
					equals: "=",
					isOn: "is on",
				},
				field: {
					profileLanguage: "Profile language",
					personalCountry: "Personal country",
				},
				validation: {
					conditionsRequired: "At least one condition is required",
					outputLanguageRequired: "Output language is required",
				},
			},
			generateBar: enGenerateBar,
		},
		campaign: {
			tabs: {
				general: "General",
				schedule: "Schedule",
				senders: "Senders",
			},
			nodePanel: {
				step: "Step {{level}}",
				sender: "Sender",
				visitProfile: "Visit LinkedIn profile",
				subjectInheritedNote:
					"The subject line is copied from the previous email step, but you can override this.",
				channels: {
					email: "Email",
					linkedinMessage: "LinkedIn Message",
					linkedinInvite: "LinkedIn Invite",
					linkedinInmail: "LinkedIn InMail",
				},
			},
			builder: {
				errorsToFix: "{{count}} errors to fix",
				invalidCampaign: "Invalid campaign",
				remove: "Remove",
				status: {
					labels: {
						INVALID: "Invalid",
						VALID: "Valid",
						READY: "Ready",
						ACTIVE: "Active",
						PAUSED: "Paused",
						ENDED: "Ended",
						LOADING: "Activating",
					},
					tooltips: {
						INVALID:
							"Campaign has errors (missing senders or sequence content) and cannot accept leads",
						VALID: "Campaign is configured correctly but no leads have been assigned yet",
						READY:
							"Campaign has leads and is ready, but isn't sending yet — activate it to start outreach",
						ACTIVE: "Campaign is actively sending messages to leads",
						PAUSED: "Campaign is paused and not sending messages",
						ENDED: "Campaign has completed all sequences or reached its stop date",
						LOADING: "Campaign is activating — schedules are being prepared before sending starts",
					},
					lock: "Campaign is locked: a step of the sequence has already been sent, so the structure, senders and channels can no longer be changed — only text edits are allowed.",
					pause: "Pause campaign",
					activate: "Activate campaign",
				},
			},
			testBanner: enCampaignTestBanner,
			sendTest: {
				title: "Send test message",
				sendButton: "Send test",
				sendButtonStandard: "Send test (standard)",
				sendButtonPremium: "Send test (premium)",
				sender: "Sender",
				recipientEmail: "Recipient email",
				recipientEmailPlaceholder: "you@example.com",
				recipientLinkedinUrl: "Recipient LinkedIn URL",
				recipientLinkedinUrlPlaceholder: "https://www.linkedin.com/in/your-handle/",
				previewTitle: "Preview",
				previewSubject: "Subject",
				previewSentTo: "Sent to",
				successToast: "Test message sent to {{sentTo}}",
				inviteVariantStandard: "Standard invite note will be used (max 200 chars)",
				inviteVariantPremium: "Premium invite note will be used (max 300 chars)",
				inviteVariantStandardShort: "standard",
				inviteVariantPremiumShort: "premium",
				inviteVariantMissing: "This invite step has no {{variant}} note configured",
				inviteVariantSenderMismatch:
					"Selected sender does not have LinkedIn Premium. The premium note may not be delivered.",
			},
		},
		register: enRegister,
		onboarding: enOnboarding,
		onboardingTour: enOnboardingTour,
		// Shared by the onboarding LANGUAGE step and the Personal Settings
		// "Copywriting settings" card — both render <SenderLanguageFields>.
		senderLanguage: {
			languagesTitle: "Which languages do you feel comfortable writing in?",
			primaryLabel: "Primary — the default when the lead speaks it",
			secondaryLabel: "Secondary — others you can write in",
			fallbackLabel: "Fallback — used when the lead's language isn't one you write in",
			alreadyPrimary: "Already your primary language",
			phrasingsTitle: "Your typical phrasings",
			phrasingsDesc: "Optional — a few of your go-to lines per language.",
			openersLabel: "Openers",
			closingsLabel: "Closings",
			ctasLabel: "Calls-to-action",
			addPlaceholder: "Type and press Enter",
		},
		email: {
			providers: {
				GOOGLE_OAUTH: "Gmail",
				MAIL: "EMAIL",
				ICLOUD: "iCloud",
				OUTLOOK: "Outlook",
				EXCHANGE: "Exchange",
				OTHER: "Other",
			},
		},
		defineIcps: enDefineIcps,
		estimatedNumEmployees: "Number of Employees",
		from_estimatedNumEmployees: "From",
		till_estimatedNumEmployees: "To",
		genderProbability: "Gender Confidence",
		from_genderProbability: "From",
		till_genderProbability: "To",
		aiColumn: {
			updateOnEachExecution: "Update on each execution",
			onceAfterFindingAValue: "Once and will stop after finding a value",
			applyToAll: "Apply to all",
			applyTo10: "Apply to first 10 rows",
			ONCE: "Once",
			DAILY: "Daily",
			WEEKLY: "Weekly",
			MONTHLY: "Monthly",
			QUATERLY: "Quarterly",
			HALFYEARLY: "Half-yearly",
			YEARLY: "Yearly",
			TEXT: "Text",
			NUMBER: "Number",
			LINK: "Link",
			BOOLEAN: "Checkbox",
			AI_PROMPT: "AI Prompt",
			RANDOM_VALUE: "Random Value",
			GOOGLE_NEWS: "Google News",
			DEPARTMENT_SIZE: "Department Size",
			LINKEDIN_POST: "LinkedIn Post",
			JOB_OFFER: "Job Offer",
			JOB_CHANGE: "Employer Change",
			TECHNOLOGY: "Technology",
			DEEP_RESEARCH: "Deep Research",
			doNotSumUpScoreOverTime: "Do not sum up score over time",
			sumUpScoreOverTime: "Sum up score over time",
			tabs: {
				posts: "Search for Posts",
				news: "Search for News",
				aiProcessing: "AI Processing",
				settings: "Settings",
			},
			button: {
				NONE: "Save",
				FIRST_10: "Apply to first 10",
				CURRENTLY_FILTERED: "Apply to filtered",
				ALL: "Apply to all",
				CURRENTLY_SELECTED: "Apply to selected",
			},
			NONE: "None",
			FIRST_10: "First 10",
			CURRENTLY_FILTERED: "Currently Filtered",
			CURRENTLY_SELECTED: "Currently Selected",
			ALL_INCLUDING_ASSIGNED: "All including assigned",
			ALL: "All",
		},
		filter: {
			noFilter: "No filter",
			textContains: "Text contains",
			textDoesNotContain: "Text does not contain",
			textStartsWith: "Text starts with",
			textEndsWith: "Text ends with",
			textIsExactly: "Text is equal",
			isIn: "Is not empty",
			isNotIn: "Is empty",
			isEmpty: "Is empty",
			isNotEmpty: "Is not empty",
			greaterEqual: "Greater equal",
			lessEqual: "Lower equal",
			between: "Between",
			dropdown: "Is in",
			dropdownCustom: "Is in",
			dropdownExclude: "Is not in",
			dropdownCustomExclude: "Is not in",
			greaterEqualDate: "Date after",
			lessEqualDate: "Date before",
			betweenDate: "Date between",
		},
		usage: {
			filtered: "Filtered",
			identified: "Identified",
			time: "Time",
			used: "Used",
			notUsed: "Not Used",
			filteredProspects: "Filtered Prospects",
			identifiedProspects: "Identified Prospects",
			aiInputTokens: "AI Input Tokens",
			aiOutputTokens: "AI Output Tokens",
			subscription: {
				intervals: {
					monthly: "Monthly",
					quarterly: "Quarterly",
					annually: "Annually",
					semiAnnual: "Semi-Annual",
				},
				intervalLabels: {
					month: "month",
					quarter: "3 months",
					halfYear: "6 months",
					year: "year",
					quarterlyDisplay: "quarterly",
					semiAnnualDisplay: "semi-annual",
					yearlyDisplay: "yearly",
					monthlyDisplay: "monthly",
				},
				intervalSubcopy: {
					month: "Flexible monthly billing.",
					quarter: "Pay in 4 installments of 3 months. 12-month commitment.",
					year: "Get 10% discount with yearly plans and all credits upfront.",
					semiAnnual: "Pay in 2 installments of 6 months. 12-month commitment.",
				},
				footnote: {
					vat: "Prices exclude VAT, which is added where applicable.",
					yearUpfront: "The whole year will be paid upfront.",
					quarterCommitment: "Billed every 3 months with a 12-month commitment.",
					semiAnnualCommitment: "Billed every 6 months with a 12-month commitment.",
				},
				checkout: enSubscriptionCheckout,
				onboarding: {
					headingIntro: "Choose a plan to start your",
					headingBrand: "free 14-day trial with 200 credits.",
					cta: "Start with 200 credits for free",
				},
				card: {
					heading: "Select a plan",
					select: "Select",
					selected: "Selected",
					whatsIncluded: "What's included",
					continueToPayment: "Continue to payment",
				},
				select: {
					headingIntro: "Choose a plan to start your",
					headingBrand: "journey with Signalist.",
					perMonth: "/ month",
					creditsHelp: "How many credits do I need?",
					creditsLabel: "{{credits}} credits / {{interval}} ({{costPerCredit}} € / credit)",
					cancel: "Cancel",
					submit: "Select plan",
					trialNotice:
						"You can cancel anytime within the trial period. If you need more credits you can always upgrade your plan.",
					features: {
						connectedLinkedinAccounts: "{{count}} connected Linkedin accounts",
						exportAllLists: "Export all lists",
						oneTimeOrOngoing: "One-time or ongoing lists",
						aiResearchAgent: "AI Web Research Agent",
						integrations: "Webhooks & Lemlist integration",
						dedicatedManager: "Dedicated Account Manager",
						standardSupport: "Standard Support",
					},
					installmentsNotAllowed:
						"Installment payments are not available for your account. Please contact support.",
				},
				change: {
					title: "Change Subscription Plan",
					confirmTitle: "Confirm Plan Change",
					selectNewPlan: "Select a new plan:",
					back: "Back",
					scheduleDowngrade: "Schedule Downgrade",
					scheduleChange: "Schedule Change",
					confirmChange: "Confirm Change",
					currentPlan: "Current Plan",
					newPlan: "New Plan",
					current: "Current",
					changeType: "Change Type:",
					chargedLabel: "You will be charged:",
					prorated: "{{amount}} (prorated)",
					effective: "Effective:",
					immediately: "Immediately",
					endOfCycle: "End of billing cycle",
					keepCurrentPlan: "You will keep your current plan until then.",
					changeTypes: {
						upgrade: "Upgrade",
						downgrade: "Downgrade",
						interval_change: "Billing interval change",
						no_change: "No change",
					},
					creditsPerInterval: "({{credits}} credits/{{interval}})",
					pricePer: "{{price}}/{{interval}}",
					priceFor3Months: "{{price}} / 3 months",
					priceFor6Months: "{{price}} / 6 months",
					pricePerMonth: "{{price}}/month",
					pricePerYear: "{{price}}/year",
					planSummary: "{{credits}} credits/{{interval}}",
				},
				overview: enSubscriptionOverview,
			},
		},
		liPost: {
			update: {
				title: "Update Linkedin Posts",
			},
			create: {
				title: "Create Linkedin Posts",
				button: "Create Linkedin Posts",
			},
			delete: {
				title: "Delete Linkedin Posts",
			},
			scrapeCriteria: "Scrape Criteria",
			filterCriteria: "Filter Criteria",
			name: "Name",
			search: "Search",
			title: "Linkedin Posts",
			subtitle: "Your Linkedin Post scrape jobs",
			query: "Keyword",
			date_posted: "Date Posted",
			relevance: "Relevance",
			authorJobTitle: "Author Job Title",
			contentType: "Content Type",
			ContentType: "Content Type",
			photos: "Photos",
			videos: "Videos",
			liveVideos: "Live Videos",
			collaborativeArticles: "Collaborative Articles",
			documents: "Documents",
			status: "Status",
			fromMember: "From Member",
			fromOrganization: "From Organization",
			authorCompany: "Author Company",
			authorIndustry: "Author Industry",
			mentionsMember: "Mentions Member",
			mentionsOrganization: "Mentions Organization",
			scrapeDaily: "Scrape Daily",
			fromTo: "From - To",
			timeFrame: "How long back should engagement be tracked?",
			fromDate: "From",
			toDate: "To",
			namePlaceholder: "Posts about #Digitalization",
			queryPlaceholder: "Digitalization",
			authorJobTitlePlaceholder: "CEO",
			titlePerson: "Title",
			headline: "Headline",
			linkedinUrl: "LinkedIn URL",
			content: "Content",
			country: "Personal Country",
			city: "Personal City",
			companyName: "Company Name",
			companyLinkedinUrl: "Company LinkedIn URL",
			companyCountry: "Company HQ Country",
			companyCity: "Company City",
			tabs: {
				results: "Results",
				costs: "Costs",
			},
			observeIndividual: "Observe Individual",
			individualExample: `"Hey Person, I saw you posted..."`,
			reactionsWithPerson: "Reactions with Person",
			reactedWithExample: `"Hey Xyz, I saw you liked Person's post..."`,
			postUrl: "Post URL",
			postUrlPlaceholder:
				"https://www.linkedin.com/posts/williamhgates_africa-decade-long-study-reveals-key-drivers-activity-7283949043293003776--eae",
			observeAction: "Observe Action",
			observeReaction: "Observe Reaction",
			maxPerPost: "Maximum Results per Post",
			maxPerPostPlaceholder: "e.g. 100",
			validateUrl: "Validate",
			validatePostUrlError: "Could not retrieve post data. Please check the URL.",
			postPreview: "Post Preview",
			keywordBuilder: "Keyword Builder",
			keywordBuilderIntro:
				"Add keywords across AND, OR and NOT rows. Press Enter to confirm each term. Signalist combines your entries into a single Boolean query that's run against LinkedIn posts — preview the composed query below.",
			andLabel: "AND",
			orLabel: "OR",
			notLabel: "NOT",
			andHelp: "must include",
			orHelp: "any of these",
			notHelp: "exclude these",
			keywordPlaceholderAnd: "Add keyword + Enter (e.g. CTO)",
			keywordPlaceholderOr: "Add keyword + Enter",
			keywordPlaceholderNot: "Add keyword + Enter (e.g. hiring)",
			composedQueryLabel: "Query",
			composedQueryEmpty: "Add keywords above to compose your query…",
			previewOnLinkedin: "Preview on LinkedIn",
			customQueryNotice:
				"This is a custom query. Editing the builder above will replace it with the composed query.",
			jobChangeTitle: "Listen for job change announcements",
			jobChangeDesc:
				'Adds a localized job-change phrase (e.g. "I\'m starting a new position as", "Ich habe einen neuen job als") to your AND row in your chosen language.',
			jobChangeLanguageLabel: "Language",
		},
		cron: enCron,
		requests: enRequests,
		map: {
			title: "Google Maps",
			subtitle: "Here you can find all your Google Maps scrapings",
			companyName: "Name",
			reviewCount: "Amount of ratings",
			rating: "Rating",
			type: "Type",
			socialMedia: "Social Media",
			companyEmail: "Email",
			website: "Website",
			companyCountry: "Company Country",
			companyCity: "Company City",
			companyState: "Company State",
			status: "Status",
			countOfResults: "Count of Results",
			scrapeDaily: "Scrape daily",
			repeatDaily: "Repeat daily",
			create: {
				title: "Create new Google Maps scraping",
			},
			delete: {
				title: "Delete Google Maps scraping",
			},
			name: "Name",
			query: "Search query",
			limit: "Limit",
			lat: "Latitude",
			lng: "Longitude",
			region: "Region",
			zoom: "Zoom",
			language: "Language",
			getInfoAt: "Search for company-wide Info@ e-mail address",
			getEnrichment: "Complete enrichment to search for special positions later on",
			getManagingDirector: "Search managing director from imprint etc",
			moreInformation: "For more information visit:",
			latPlaceholder: "41,12456",
			lngPlaceholder: "29,12456",
			limitPlaceholder: "100",
			queryPlaceholder: "Restaurants in London, United Kingdom",
			zoomPlaceholder: "10",
			languagePlaceholder: "en",
			regionPlaceholder: "uk",
			scrapeLevel: "Scrape Level",
			phoneNumber: "Phone Number",
			tabs: {
				results: "Results",
				costs: "Costs",
			},
			fromUrlPlaceholder: "Paste your Google Maps URL",
			fromUrl: "From URL",
		},
		companies: enCompanies,
		company: {
			title: "Your Company",
			heading: "Company Settings",
			tabs: {
				general: "General Settings",
				user: "Users",
				contacts: "Contacts & Enrichment",
				integrations: "API, Webhooks & Integrations",
				developer: "API & Webhooks",
				apiKeys: "API Keys",
				costs: "Costs",
				blacklist: "Blacklist",
				usage: "Usage",
				billing: "Plans & Billing",
				copywriting: "Copywriting",
			},
			companyInformation: "Company Information",
			autoInvite: "Auto Invite to your company linkedin page",
			apolloApiKey: "Apollo API Key",
			lemlistApiKey: "Lemlist API Key",
			hubspotApiKey: "HubSpot Private App Access Token",
			...enCrmProviders,
		},
		blacklist: enBlacklist,
		score: {
			title: "Lead Scoring",
			subtitle: "Here you can find all your lead scores",
			create: {
				button: "Create New Score",
				title: "Create New Score",
			},
			description: "Description",
			search: "Search for score",
			name: "Name",
			TITLE: "Title",
			SENIORITY: "Seniority",
			LOCATION: "Location",
			COMPANY_LOCATION: "Company Location",
			EMPLOYEES: "Employees",
			INDUSTRY: "Industry",
			KEYWORDS: "Keywords",
			NUMBER_IN_LEAD_FILTER: "Number in Lead Filter",
		},
		scoring: {
			changeCompanyCategory: "Change Company Category",
			changeCompanyCategoryFor: "Change company category for {{name}}",
			changePersonaCategory: "Change Persona Category",
			changePersonaCategoryFor: "Change persona category for {{name}}",
			companyCategory: "Company category",
			personaCategory: "Persona category",
			reasonForChange: "Reason for change",
			reasonPlaceholder: "Enter reason for this change...",
		},
		channelPills: {
			linkedin: "LinkedIn",
			email: "Email",
			phone: "Phone",
			status: {
				found: "found",
				missing: "missing",
				enriching: "enriching",
			},
		},
		inbox: enInbox,
		dashboard: {
			title: "Welcome",
			subline: "Here's what needs your attention today.",
			loadError: "We couldn't load your dashboard. Please refresh the page.",
			newLeads: {
				title: "New leads",
				subtitle: "{{lists}} lists added {{count}} new leads in the last 30 days",
				empty: "No lists with new prospects right now.",
				including: "Including",
				andMore: "and {{count}} more",
				reviewAll: "Review all new leads",
				openList: "Open the list",
				seeAll: "See all lead lists →",
				bulkReview: "Review new leads across all lists",
				bulkReviewCount: "{{count}} new in the last 30 days",
				status: {
					IDLE: "Idle",
					ERROR: "Error",
					PROCESSING: "Processing",
					DESKTOP_APP: "Waiting on desktop app",
					API_WAITING: "Waiting on API",
					WAITING: "Waiting",
					DONE: "Done",
					NO_USER_FOUND: "No matches found",
					NOT_ENOUGH_CREDITS: "Out of credits",
					WAITING_FOR_SESSION: "Waiting for LinkedIn session",
				},
			},
			reengage: {
				title: "Contacts to re-engage",
				subtitle: "Leads surfaced by your Smart Lists — each list sets its own criteria",
				empty: "No leads to re-engage right now.",
				viewAll: "View all {{count}} →",
			},
		},
		outbox: enOutbox,
		feed: enFeed,
		list: {
			reachOut: enReachOut,
			outreach: enOutreach,
			sourceFilter: enListSourceFilter,
			detailsStep: enListDetailsStep,
			copyCampaigns: {
				title: "Select Campaigns",
				submit: "Copy Campaigns",
				searchPlaceholder: "Search lists or campaigns",
				noResults: "No campaigns available to copy",
				noSearchResults: 'No lists or campaigns match "{{query}}"',
				campaignCount_one: "{{count}} campaign",
				campaignCount_other: "{{count}} campaigns",
				valid: "Valid",
				invalid: "Invalid",
			},
			campaignBuilder: enCampaignBuilder,
			assignCoachmark: {
				selectLeads: "Select one or more leads to start assigning them to your campaign.",
				openReachOut: 'Now click "Reach out" to choose how to contact them.',
				addToCampaign: 'Click "Add to campaign" to assign the selected leads to your campaign.',
				close: "Dismiss",
			},
			pendingEmail: {
				title: "Other emails found",
				description:
					"Emails found for this lead during outreach. Make one the primary email or dismiss it.",
				makePrimary: "Make primary",
				reject: "Reject",
				confirmed: "Primary email updated",
				rejected: "Email dismissed",
				error: "Could not update the email. Please try again.",
			},
			EMPTY: "Manual",
			title: "Lead Lists",
			ownership: {
				mine: "My Lists",
				team: "Team lists",
				all: "All lists",
				searchResults: "Search Results",
				scope: "Scope",
			},
			emptyState: {
				myLists: {
					title: "Create your first list",
					description:
						"You haven't built any lists yet. Start one from scratch, or browse what your team already has.",
					createList: "Create a list",
					seeAllLists: "See all lists",
				},
			},
			pinTab: {
				trigger: "Pin to tab",
				popoverTitle: "Pin this view to a tab",
				popoverSubtitle: "Save your current filters as a named tab you can return to anytime.",
				nameLabel: "Tab name",
				namePlaceholder: "e.g. Active event campaigns",
				save: "Pin tab",
				cancel: "Cancel",
				rename: "Rename tab",
				update: "Update to current filters",
				delete: "Delete tab",
				defaultName: "My saved view",
				pinnedToast: 'Pinned "{{name}}" as a new tab',
				updatedToast: 'Updated "{{name}}" to current filters',
				deletedToast: 'Deleted tab "{{name}}"',
				errorToast: "Something went wrong. Please try again.",
				criteria: {
					search: "Search",
					scope: "Scope",
					show: "Show",
					source: "Source",
					archived: "Archived",
					archivedValue: "Shown",
				},
			},
			search: "Search for lists...",
			searchInList: "Search in list...",
			listPicker: {
				searchPlaceholder: "Search lists...",
				archived: "Archived ({{count}})",
				noResults: "No lists found",
			},
			scopeFilter: enListScopeFilter,
			sort: "Sort",
			name: "Name",
			source: "Source",
			sourceType: "Source Type",
			leadFilter: "Lead Filter",
			linkedIn: {
				linkedInHeadline: "LinkedIn Headline",
				linkedInAbout: "LinkedIn About",
			},
			accountFilter: "Account Filter",
			processingStatus: "Processing Status",
			enrichments: "Enrichments",
			downloads: "Downloads",
			allIncludingExcluded: "All including excluded",
			editList: "Edit List",
			editCampaign: "Edit Campaign",
			goToAnalytics: "Go to analytics",
			editListNew: "Edit List (New)",
			deleteList: "Delete List",
			resetList: "Reset List",
			archiveList: "Archive List",
			unarchiveList: "Unarchive List",
			download: "Download",
			create: {
				button: "Create New List",
				title: "Create New List",
				catalog: {
					empty: "No list types match — try a different search or describe what you want to do.",
					disabled: {
						noWebsiteScrapeCredits:
							"Scraping a website or mobile app requires an available scrape job. Click to buy scrape jobs.",
						noSalesNavigator: "No Sales Navigator profiles found.",
						noLinkedin: "No users found that are connected to LinkedIn.",
						noCompanyAdmin:
							"No users found that have admin permissions on a LinkedIn company page.",
					},
					filters: {
						ALL: "All",
						RECURRING: "Recurring",
						ONE_TIME: "One-time",
						NO_REQUIREMENTS: "No requirements",
					},
					sectionDescriptions: {
						UPLOAD: "Bring your own list of people, companies or job titles",
						SCRAPING: "Let our team scrape participant, exhibitor or login-protected lists",
						LINKEDIN: "Who posts, engages, attends events, visits or follows your profiles",
						DATABASE: "Import leads from our database, LinkedIn, Sales Navigator or Google Maps",
						JOBS: "Track companies that are hiring and people changing jobs",
						FUNDING: "Companies that raised funding or were acquired — plus their leads",
						SIGNALS: "Monitor people & companies for custom signals and job changes",
						REENGAGE: "Reach existing contacts again",
						EMPTY: "Start blank and add people manually or from other lists",
					},
					rail: {
						all: "All lists",
						favorites: "My favorites",
						addFavorite: "Add to favorites",
						removeFavorite: "Remove from favorites",
						categories: {
							UPLOAD: "Upload & webhook",
							SCRAPING: "Scraping service",
							LINKEDIN: "LinkedIn activity",
							DATABASE: "Lead databases",
							JOBS: "Jobs & changes",
							FUNDING: "Funding & M&A",
							SIGNALS: "Custom signals",
							REENGAGE: "Re-engage",
							EMPTY: "Empty list",
						},
						favoritesEmpty: {
							title: "No favorites yet",
							description:
								"Star any list type to pin it here for quick access next time you build a list.",
						},
					},
					recurrence: {
						recurring: "Recurring",
						oneTime: "One-time",
					},
					ai: {
						placeholder: "Search in all lists",
						examplesLabel: "Examples:",
						examples: {
							event: {
								label: "Find people at an event I'm attending",
							},
							competitor: {
								label: "Track competitor engagement",
							},
							funding: {
								label: "Find startups raising funds",
							},
							followers: {
								label: "Track followers of my company page",
							},
							engagement: {
								label: "Find people engaging with me on Linkedin",
							},
							hiring: {
								label: "Find companies hiring",
							},
							leads: {
								label: "Find new leads and lookalikes",
							},
							signals: {
								label: "Track signals of my target leads and accounts",
							},
						},
					},
					requirements: {
						LINKEDIN_ACCOUNT: {
							label: "LinkedIn account",
							description: "Requires at least one connected LinkedIn account.",
						},
						SALES_NAVIGATOR: {
							label: "Sales Navigator",
							description: "Requires a connected LinkedIn Sales Navigator account.",
						},
						COMPANY_ADMIN: {
							label: "Company admin",
							description: "Requires LinkedIn company page admin permissions.",
						},
						WEBSITE_SCRAPE_CREDITS: {
							label: "Scrape job",
							description: "Requires an available scraping credit.",
						},
						TRACKER_AS_LIST_FEATURE: {
							label: "Tracker feature",
							description: "Requires the tracker-as-list feature flag.",
						},
					},
				},
			},
			delete: {
				title: "Delete List",
				confirmation: "Are you sure you want to delete this list?",
				titleSelected: "Delete selected lists",
				confirmationSelected: "Are you sure you want to delete the selected lists?",
			},
			reset: {
				title: "Reset List and remove assigned prospects",
				confirmation: "Are you sure you want to reset this list?",
			},
			rerun: enListRerun,
			noFile: enListNoFile,
			tracker: {
				monitoring: "Monitoring",
				trackingCount_one: "Tracking {{count}} company",
				trackingCount_other: "Tracking {{count}} companies",
			},
			viewSwitcher: {
				list: "List",
				review: "Review",
				feed: "Feed",
			},
			openInReview: {
				title: "Open in Review",
				subtitle: "Choose which leads to review and send.",
				confirm: "Open Review",
				scopeSelected: "Selected leads",
				scopeSelectedDesc: "Only the leads you've checked in this view",
				scopeFiltered: "Filtered leads",
				scopeFilteredDesc: "All leads matching your current filters",
				scopeTab: 'All leads in "{{tab}}"',
				scopeTabDesc: "Everything in the current status tab",
				scopeAll: "All leads in this list",
				scopeAllDesc: "Across all status tabs and filters",
			},
			show: {
				showMore: "Show More",
				showLess: "Show Less",
			},
			archive: {
				title: "Archive List",
				confirmation: "Are you sure you want to archive this list?",
			},
			unarchive: {
				title: "Unarchive List",
				confirmation: "Are you sure you want to unarchive this list?",
			},
			preview: {
				company_disqualified: "Company disqualified",
				company_not_found: "Company not found",
				not_found: "Not found",
				title: "Preview your search results",
				description:
					"Test your ICP and override rules on a small sample of companies before running the full list. In the preview we only search for one person per company.",
				startPreview: "Start Preview",
				stopPreview: "Stop Preview",
				rerunPreview: "Re-run Preview",
				extendPreview: "Extend Preview",
				inProgress: "Preview in progress",
				companiesProcessed: "{{processed}} of {{total}} companies processed...",
				completed: "Preview completed",
				stopped: "Preview stopped",
				failed: "Preview failed",
				found: "Found",
				unsure: "Unsure",
				notFound: "Not Found",
				skipped: "Skipped",
				companyCount: "Companies",
				selectCompanyCount: "Select company count",
				company: "Company",
				personFound: "Person Found",
				via: "Via",
				status: "Status",
				statusReason: "Reason",
				creditsUsed: "Credits used",
				estimatedFullListCredits: "Est. full list credits",
				rerunModal: {
					title: "Re-run Preview",
					description: "Choose how to handle previously found leads when re-running the preview.",
					keepFound: "Keep found leads",
					keepFoundDescription:
						"Only re-process companies where no lead was found or the match was uncertain.",
					discardAll: "Discard all & start fresh",
					discardAllDescription:
						"Remove all previous results and re-process all companies from scratch.",
				},
				matchedVia: {
					PROFILE_1: "Profile 1",
					PROFILE_2: "Profile 2",
					PROFILE_3: "Profile 3",
					AI: "AI",
					OVERRIDE_RULE: "Override Rule",
				},
				insufficientCredits: "Insufficient credits to start the preview.",
				alreadyRunning: "A preview is already running for this list.",
				noResults: "No results yet",
			},
			processed: "Processed",
			found: "Found",
			downloadSelected: "Download selected",
			subtitle: "Your Lead Lists",
			sources: enListSources,
			account: {
				title: "Company Filter",
				search: "Search for company filter",
				name: "Name",
				subtitle: "Choose a company filter",
			},
			scores: {
				title: "Lead Scoring",
			},
			lead: {
				title: "Department Filter",
				search: "Search for department filter",
				name: "Name",
				subtitle: "Choose a department filter",
				type: "Typ",
			},
			aiEnrichment: {
				title: "Enrichments",
				search: "Search for Enrichment",
				name: "Name",
				subtitle: "Choose Enrichments",
				type: "Enrichment Type",
			},
			campaign: {
				title: "Campaigns",
				search: "Search for campaigns",
				name: "Name",
				subtitle: "Choose a target campaign",
				sync: "Sync campaigns",
			},
			settings: {
				title: "Settings",
				subtitle: "Settings",
				name: "Name",
				maxProspects: "max Prospects",
				maxProspectsPerDay: "Max. Prospects per day",
				maxPerCompany: "max per company",
				...enListSettingsPrices,
				withLinkedin: "prospect needs to have LinkedIn",
				onlyNewLeads: "only new leads - leads that have not been added to other lists",
				once: "One-time",
				ongoing: "Recurring",
				WEBHOOK_ALL_QUALIFIED_LEADS: "All found leads",
				WEBHOOK_ALL_LEADS_INCLUDING_NOT_FOUND: "All leads including not found",
				WEBHOOK_WHEN_REPLIED: "When lead replied",
				WEBHOOK_ALL_LEADS: "All leads (Found & Unsure)",
				WEBHOOK_WHEN_ASSIGNED: "When assigned",
				priority: {
					LOW: "Low",
					MEDIUM: "Medium",
					HIGH: "High",
				},
				...enListCrmSettings,
				// UI Labels
				listName: "List Name",
				listPriority: "List Priority",
				listType: "List Type (Frequency)",
				recurrenceLabel: "Run frequency",
				recurrenceDaily: "Every day",
				recurrenceWeekly: "Every week",
				recurrenceMonthly: "Every month",
				stopAddingLeadsAfter: "Stop adding leads to the list after",
				numberOfLeads: "# of Leads (per day/total)",
				numberOfLeadsPlaceholder: "e.g. 100",
				date: "Date",
				findContactInformationTitle:
					"Find contact information like email phone number and company phone number",
				findContactInformationInfo:
					"We will enrich each person or company only once. That means, if we already enriched a person or company in another of your lists, we will not charge credits for it.",
				onlyNewLeadsLabel: "Only add new leads that have not been added to other lists before",
				advancedSettings: "Advanced settings",
				advancedSettingsDescription: "Default campaign assignments, webhooks and more",
				selectDefaultCampaign: "Select default campaign",
				selectCampaignPlaceholder: "Select Campaign",
				loadingCampaigns:
					"Loading Campaigns... (If we do not find the campaign, we will resync with Lemlist. This can take up to 10 seconds, depending on the amount of campaigns)",
				sendLeadsToWebhook: "Send leads to a webhook",
				// Auto-assign to campaign
				autoAssignToCampaign: "Auto-assign to campaign",
				autoAssignToCampaignInfo:
					"Once a person is found, enroll the lead in the campaign of the first routing rule it matches, else the list's fallback (the default campaign, or none)",
				autoAssignMinScore: "Minimum score",
				autoAssignMinScoreRequired: "Please select a minimum score when auto-assign is enabled",
				autoAssignScore1: "Priority 1 (highest)",
				autoAssignScore2: "Priority 2",
				autoAssignScore3: "Priority 3",
				autoAssignScoreDisqualified: "All (including disqualified)",
				// View dropdown
				view: "View",
				viewLeadList: "Lead list",
				viewSources: "Sources",
				viewFindPerson: "Find person",
				viewCompanyQualification: "Company Qualification",
				viewCampaigns: "Campaigns",
				viewListSettings: "List Settings",
				viewSignals: "Signals",
				// Breadcrumb
				createListTitle: "Create {sourceType} List",
				// Activate List Modal
				activateListTitle: "Activate list",
				activateListButton: "Activate",
				goToListsButton: "Go to Lists",
				activateListDescription1:
					"You can activate the list now or at any time on the overview page to start processing the sources and leads. Depending on the amount of leads this may take a few minutes or up to a few hours.",
				activateListDescription2:
					"Once the list is ready we will send you an email. Daily lists only send a notification the first time the list has been processed.",
				activateOutreachLabel: "Activate outreach for this list",
				activateOutreachInfo:
					"Once there are leads in the list, you will be able to send messages to the leads from review to send or follow up.",
				// Block messages
				blockListFrequencyEnrichment:
					"This list is blocked because the enrichment will be done once.",
				blockListFrequencyEvent:
					"This list is blocked because the scraping will have to be done more than once.",
				blockListFrequencyJobChange:
					"Job change tracking lists are automatically set to ongoing monitoring.",
				blockListFrequencyTracker: "Tracker lists are automatically set to ongoing monitoring.",
				blockListFrequencyMonitor:
					"Lists with a Parallel AI monitor are automatically set to ongoing monitoring.",
				// Job Change tracking fields
				jobChangeCheckIntervals: "Job Change Check Intervals",
				jobChangeIntervalPrio1: "Priority 1 check interval",
				jobChangeIntervalPrio2: "Priority 2 check interval",
				jobChangeIntervalPrio3: "Priority 3 check interval",
				jobChangeIntervalDisqualified: "Disqualified check interval",
				jobChangeIntervalPlaceholder: "Enter number",
				jobChangeIntervalUnits: {
					DAYS: "Days",
					WEEKS: "Weeks",
					MONTHS: "Months",
					YEARS: "Years",
				},
				jobChangeMinScoreTitle: "Minimum Score Threshold",
				jobChangeMinScoreDescription:
					"When a job change is detected, only leads with this score or higher will be automatically added as active leads",
				jobChangeMinScore: "Minimum score to add as lead",
				jobChangeMinScore1: "Priority 1 only",
				jobChangeMinScore2: "Priority 1 & 2",
				jobChangeMinScore3: "Priority 1, 2 & 3",
				jobChangeMinScore4: "All (including Disqualified)",
				// Job Change settings section
				jobChangeSettings: "Job Change Settings",
				jobChangeSettingsDescription:
					"Configure how job changes are tracked and when leads should be added",
				jobChangeSettingsDescriptionSubtitle:
					"Leads can be added manually again to the job change tracking.",
				// Job Change deactivation settings
				jobChangeDeactivateChangedEmployer:
					"Add to new and stop tracking for leads that have changed employers.",
				jobChangeDeactivateChangedRole:
					"Add to new and stop tracking for leads that have changed roles.",
				jobChangeDeactivateAddedEmployer:
					"Add to new and stop tracking for leads that have added an employer.",
				jobChangeDeactivateAddedRole:
					"Add to new and stop tracking for leads that have added a role.",
				// Job Change tracking frequency
				jobChangeTrackingFrequency: "Select tracking frequency",
				jobChangeCheckPrio1: "Check Prio 1 Leads",
				jobChangeCheckPrio2: "Check Prio 2 Leads",
				jobChangeCheckPrio3: "Check Prio 3 Leads",
				jobChangeCheckDisqualified: "Check Disqualified Leads",
				jobChangeEvery: "Every",
				jobChangeCreditsPerRun: "0.1 credits per lead per run",
				jobChangeDqNote: "*DQ leads that get added will automatically be assigned as Prio 3 leads",
				// Signal Scoring Intervals section (for TRACKER lists)
				signalSettings: "Signal Scoring Intervals",
				signalSettingsDescription:
					"Configure how often signal scoring checks are performed for tracked entities",
				signalTrackingFrequency: "Select tracking frequency",
				signalCheckPrio1: "Check Priority 1",
				signalCheckPrio2: "Check Priority 2",
				signalCheckPrio3: "Check Priority 3",
				signalEvery: "Every",
				signalCreditsPerRun:
					"2 credits per company (incl. 1 person) per run, +0.1 per additional person",
				// Signal interval mode configuration
				signalIntervalMode: "Signal Check Mode",
				signalIntervalModeDescription: "Choose how signal checks are scheduled",
				signalModeRolling: "Rolling",
				signalModeRollingDescription:
					"Each entity is checked based on time elapsed since its last check",
				signalModeFixed: "Fixed",
				signalModeFixedDescription:
					"All entities are checked on the same schedule dates, aligned to a start date",
				signalScheduleStartDate: "Schedule Start Date",
				// Smart List frequency
				updateFrequency: "Update Frequency",
				DAILY: "Daily",
				WEEKLY: "Weekly",
				MONTHLY: "Monthly",
			},
			overrideRules: {
				title: "Override Rules",
				subtitle: "Override the default search profile order based on If/Then criteria",
				if: "If",
				and: "and",
				thenSearchFor: "Then search for",
				in: "in",
				first: "first",
				addRule: "Add rule",
				deleteRule: "Delete rule",
				rule: "rule",
				rulesCount: "rules",
				valuePlaceholder: "value",
				customTitlePlaceholder: "Enter job title",
				infoText:
					"If no rule matches, or if the rule-based search doesn't find a person, the system tries your Search Profiles 1 → 2 → 3 as configured above, searching each in the people database and then with AI before moving to the next profile.",
				criteria: {
					employees: "Number of Employees",
					hqCountry: "Company HQ Country",
					industry: "Industry",
					segment: "Company Segment",
					founded: "Founded Year",
				},
				operators: {
					lt: "is less than",
					gt: "is greater than",
					between: "is between",
					eq: "is equal to",
					is: "is",
					is_not: "is not",
				},
				actions: {
					ceo: "CEO / Founder",
					persona: "Persona Category ▸",
					custom: "Specific title ▸",
				},
				locations: {
					anywhere: "Anywhere",
					hqCountry: "Same country as company HQ",
					specific: "Specific country ▸",
				},
			},
			sourceTypes: {
				JOB_CHANGE: "Job Change",
				TRACKER: "Tracker",
				SMART_LIST: "Smart List",
			},
			additionalSources: {
				title: "Person filter",
				search: "Search for additional source",
				name: "Name",
				subtitle: "Choose additional sources",
			},
			status: {
				title: "Status",
				DONE: "Done",
				WAITING: "Waiting",
				IDLE: "Idle",
				PROCESSING: "Processing",
				IN_PROGRESS: "Processing",
				DESKTOP_APP: "Waiting for Browser Extension",
				API_WAITING: "Processing",
				DRAFT: "Created",
				ERROR: "Error",
				NO_USER_FOUND: "No LinkedIn login",
				NOT_ENOUGH_CREDITS: "Not enough credits",
				WAITING_FOR_SESSION: "Waiting for available session",
				STOPPING: "Stopping…",
				campaignStatus: "Campaigns",
				stoppingTooltip: "List is stopping, please wait…",
				stoppingError: "List is still stopping. Please wait until it is fully paused.",
			},
			ListType: "Source Type",
			searchBase: "Search and filter basis",
			regularity: "Repeat search",
			log: {
				tabs: {
					settings: "Configuration",
					logs: "Logs",
					costs: "Costs",
				},
			},
			iteration: "Iteration",
			automaticUpdate: "Automatic update",
			loadMore: "Load more",
			lastUpdatedAt: "Last Updated At",
			lastModifiedAt: "Last modified at",
			lastModifiedBy: "Last modified by",
			newLeads: "Open",
			assignedLeads: "Assigned",
			savedForLater: "To be reviewed",
			campaignSettings: "Campaign settings",
			createNewCampaign: "Create new campaign",
			viewLeads: "View leads",
			listSettings: "List settings",
			enrichment: {
				title: "Enrichment",
				active: "Active",
				deactivated: "Deactivated",
				activate: "Activate",
				deactivate: "Deactivate",
			},
			campaignMetrics: enListCampaignMetrics,
			campaignBulk: enListCampaignBulk,
			campaignRollup: enListCampaignRollup,
			filter: {
				ALL: "All lists",
				WITH_LEADS: "Only lists with leads",
				WITH_CAMPAIGNS: "Only lists with campaigns",
				WITH_ACTIVE_CAMPAIGNS: "Only lists with active campaigns",
			},
			archivedView: {
				HIDE: "Hide archived lists",
				SHOW: "Show archived lists",
			},
			sorting: {
				nameASC: "Sort A -> Z",
				nameDESC: "Sort Z -> A",
				leadsASC: "Leads Ascending",
				leadsDESC: "Leads Descending",
			},
			namePlaceholder: "Name of the list",
			CUSTOM_EVENTS: "Website",
			assignStatus: {
				unassigned: "New",
				assigned: "Assigned",
				blacklist: "Blacklist",
				notNow: "Contact later",
				underReview: "Under Review",
			},
			notArchived: "Not archived",
			archived: "Archived",
			archiveStatus: "Archive status",
			reengage: {
				pageTitle: "Create Contacts to Re-engage List",
				infoBannerTitle: 'How "Contacts to re-engage" lists work',
				infoBanner:
					"We scan your contacts every day and surface anyone who matches your re-engagement criteria — typically leads who showed interest in the past but haven't been contacted in a while. New matches are added automatically.",
				addSourceTitle: "Add Source",
				editSourceTitle: "Edit Source",
				addSourceSub:
					"Define which contacts should be re-surfaced. Each source you add creates its own daily scan.",
				sourceName: "Source Name",
				sourceNamePlaceholder: "e.g. Interested leads from Q3 — re-check after 3 months",
				criteriaTitle: "Re-engagement criteria",
				criteriaSub: "Who should we re-surface?",
				fromList: "From List",
				allLists: "All lists",
				bestSentiment: "Best Sentiment is",
				anySentiment: "Any sentiment",
				lastContact: "Last contact",
				lastContact_1m: "1 month ago or earlier",
				lastContact_2m: "2 months ago or earlier",
				lastContact_3m: "3 months ago or earlier",
				lastContact_6m: "6 months ago or earlier",
				lastContactCustom: "Custom range…",
				lastContactRangePlaceholder: "Select date range",
				leadScoringTitle: "Lead Scoring Filters",
				leadScoringSub: "Narrow down by fit",
				companyCategory: "Company Category",
				allCategories: "All categories",
				personaCategory: "Persona Category",
				allPersonas: "All personas",
				leadScoring: "Lead Scoring",
				allScores: "All scores",
				advancedFilters: "Advanced filters",
				locations: "Locations",
				companyHqLocation: "Company HQ Location",
				personalLocation: "Personal Location",
				allLocations: "All locations",
				previewMatching: "Preview matching contacts",
				previewResult: "Matching contacts",
				addSource: "Add Source",
				saveSource: "Save Source",
				addedSources: "Added Sources",
				addedSourcesSub: "Each source runs daily and adds new matching contacts to this list.",
				rechecksDaily: "Re-checks daily",
				edit: "Edit",
				remove: "Remove",
				emptyTitle: "No sources added yet",
				emptySub: "Configure your re-engagement criteria on the left and click Add Source.",
				pointerTitle: "Need more advanced filtering?",
				pointerBody:
					"For complex re-engagement plays, head to Contacts. Combine 30+ filters, save as a Smart List, or run a semantic search to pull leads into a list.",
				openContacts: "Open Contacts",
				trySemanticSearch: "Try semantic search",
				bottomBarHint: "Add at least one source to continue.",
				nextCampaigns: "Next: Outreach",
				multiSelect: "Multi-select",
				singleSelect: "Single-select",
				requiredField: "This field is required",
			},
			stepper: {
				details: "Find person",
				source: "Sources",
				filter: "Company Qualification",
				smartListFilter: "Filters",
				score: "Scoring",
				settings: "Settings",
				events: "Events",
				copywriting: "Outreach",
				signals: "Signals",
				leadList: "Lead List",
				viewLeadList: "View Lead List",
			},
			signals: enListSignals,
			JOBS: "Jobs",
			PARALLEL_AI: "AI Prompt ",
			LI_EVENTS: "LinkedIn Events",
			CSV_ENRICHMENTS: "Excel Upload",
			LI_COMPANY_ACTIVITY: "Scrape Linkedin Company Follower",
			LI_POST: "LinkedIn Posts",
			LI_PROFILE_VISITS: "LinkedIn Personal Profile Visits",
			PROSPECT_SEARCH: "Prospect Search",
			LI_PROFILE: "LinkedIn Profile Tracking",
			LINKEDIN_PROFILE_POSTS: "LinkedIn Profile Posts",
			LINKEDIN_PROFILE_COMMENTS: "LinkedIn Profile Comments",
			LINKEDIN_PROFILE_LIKES_TO_POST: "LinkedIn Profile Likes to Post",
			LINKEDIN_PROFILE_LIKES_TO_COMMENT: "LinkedIn Profile Likes to Comment",
			LINKEDIN_PROFILE_COMMENTS_TO_POST: "LinkedIn Profile Comments to Post",
			LI_SN: "LinkedIn Sales Navigator",
			FUNDING_ROUNDS: "Funding Rounds & M&A Activities",
			LEAD_DATABASE: "Lead Database",
			COMPANY_ENRICH: "Lead Database",
			LI_PEOPLE: "LinkedIn People Search",
			JOB_CHANGE: "Job Change Tracking",
			TRACKER: "Tracker",
			SMART_LIST: "Smart List",
			LI_CONNECTIONS: "LinkedIn Connections",
			lastActivity: "Last Activity",
			duplicate: {
				title: "Duplicate List",
				confirmation: "Are you sure you want to duplicate this list?",
			},
			company: "Company",
			newName: "New Name",
			lastAddedAt: "Last prospect added at",
			MAPS: "Google Maps",
			LISN: "Linkedin Sales Navigator",
			companySegments: {
				title: "Company Segments",
				subtitle:
					"Select which company segments to include. Companies not matching any selected segment will be skipped or disqualified through the Lead Scoring. When no company segment is selected, all companies will be included.",
				selectAll: "Select all",
			},
			profiles: "Profiles",
			addPerson: "Add Person",
			selectProspect: "Select prospect",
			personNotFound: "Person not found",
			addToList: "Add to List",
			noOrganizationProfiles: "No other colleagues found from this organization.",
		},
		enum: {
			searchBase: {
				PERSON: "People from source. Can be filtered.",
				COMPANY: "Companies from source. Needs person filter to get employees.",
				SOURCE: "Google Maps / Jobs without people. Only info@ email addresses.",
			},
		},
		northdata: {
			title: "Federal Gazette",
			search: "Search for Federal Gazette",
			name: "Name",
			lastDays: "Last Days",
			status: "Status",
			type: "Type",
			create: {
				button: "Create New Federal Gazette Search",
				title: "Create New Federal Gazette Search",
			},
			subtitle: "Your Federal Gazette Searches",
			delete: {
				title: "Delete Federal Gazette Search",
			},
		},
		stepstone: {
			title: "Stepstone",
			search: "Search for Stepstone",
			name: "Name",
			status: "Status",
			subtitle: "Your Stepstone Data",
			company: "Company",
			url: "URL of Stepstone data",
			maxJobOffers: "Max Job Offers",
			email: "Email",
			found: "Found",
			processed: "Processed",
			create: {
				button: "Create new Stepstone",
				title: "Create new Stepstone",
			},
		},
		indeed: {
			title: "Indeed",
			search: "Search for indeed",
			name: "Name",
			status: "Status",
			subtitle: "Your indeed Data",
			company: "Company",
			url: "URL of Indeed data",
			maxJobOffers: "Max Job Offers",
			email: "Email",
			found: "Found",
			processed: "Processed",
			create: {
				button: "Create new Indeed",
				title: "Create new Indeed",
			},
		},
		customEvent: enCustomEvent,
		liEvent: {
			allowScrape: "Allow scrape",
			title: "LinkedIn Events",
			search: "Search for event",
			name: "Name",
			attendees: "Attendees",
			status: "Status",
			company: "Company",
			eventAt: "Event at",
			subtitle: "Your LinkedIn events",
			url: "URL of specific LinkedIn Event",
			urls: "URLs of Linkedin Event Search",
			searchTerm: "Search term for event search",
			lastRunAt: "Last run at",
			nextRunAt: "Next run at",
			email: "Email",
			employees: "Employees",
			annualRevenue: "Annual revenue",
			specific: "Specific Search",
			defaultSearch: "Default search",
			create: {
				button: "Create new Event Search Scraper",
				title: "Create new Event Search Scraper",
			},
			update: {
				title: "Update Event Search Scraper",
			},
			minDaysBeforeScrape: "Scrape X days before event start",
			minAttendeesBeforeScrape: "Scrape if X attendees are attending despite date",
			scrapeCriteria: "Scrape criteria",
			filterCriteria: "Filter criteria",
			profileLanguages: "Profil languages",
			english: "English",
			german: "German",
			spanish: "Spanish",
			french: "French",
			portuguese: "Portuguese",
			addToSearch: "Add to search",
			save: "Save",
			titleKeyword: "Title keyword",
			fromOrganization: "From Organization",
			validateUrl: "Validate URL",
			validating: "Validating...",
			eventPreview: "Event Preview",
			eventTitle: "Title",
			eventDescription: "Description",
			eventDate: "Event Date",
			eventCompany: "Company",
			eventUrn: "Event URN",
			invalidUrl: "Invalid LinkedIn event URL",
			validationFailed: "Could not validate the event URL. Please check the URL and try again.",
		},
		liPeople: {
			connectionsOf: {
				label: "Connections of",
			},
			title: "LinkedIn People Search",
			search: "Search for people",
			name: "Name",
			subtitle: "Your LinkedIn people searches",
			urls: "URLs of Linkedin People Search",
			urlsPlaceholder:
				"https://www.linkedin.com/search/results/people/?keywords=marketing&origin=FACETED_SEARCH&sid=xz%2C",
			urlTitle: "URLs",
			create: {
				button: "Create new People Search Scraper",
				title: "Create new People Search Scraper",
			},
			update: {
				title: "Update People Search Scraper",
			},
			defaultSearch: "Default search",
			specific: "Specific Search Url(s)",
			keyword: "Keyword",
			titleFreeText: "Title Freetext",
			companyFreeText: "Company Freetext",
			firstName: "First Name",
			lastName: "Last Name",
			location: {
				label: "Location",
			},
			language: {
				label: "Language",
			},
			serviceCategory: {
				label: "Service Category",
			},
			industry: {
				label: "Industry",
			},
			schoolFreeText: "School Freetext",
			school: {
				label: "School",
			},
			currentCompany: {
				label: "Current Companies",
			},
			previousCompany: {
				label: "Past Companies",
			},
			followerOf: {
				label: "Follower of",
			},
			specificTags: "Specific Tags",
			personalDetails: "Personal Details",
			namePlaceholder: "New Linkedin People Search",
			keywordPlaceholder: "Digitalization",
			titleFreeTextPlaceholder: "CEO",
			companyFreeTextPlaceholder: "Digital Now",
			firstNamePlaceholder: "Bill",
			lastNamePlaceholder: "Gates",
			schoolFreeTextPlaceholder: "Harvard",
		},
		liCompanyActivity: enLiCompanyActivity,
		liProfileVisits: enLiProfileVisits,
		liProfile: enLiProfile,
		openAi: enOpenAi,
		apiKey: enApiKey,
		cookie: enCookie,
		adminFixes: enAdminFixes,
		apiHealth: enApiHealth,
		webhookHealth: enWebhookHealth,
		webhookLists: enWebhookLists,
		webhookSigning: enWebhookSigning,
		leadScoring: enLeadScoring,
		analytics: enAnalytics,
		...enFeatureUsageTranslations,
		helpCenter: enHelpCenter,
		supportDashboard: enSupportDashboard,
		profileTracker: enProfileTracker,
		csvEnrichment: enCsvEnrichment,
		prospectSearch: enProspectSearch,
		prospects: {
			title: "Prospects",
			search: "Search for prospect",
			campaignSearch: "Search for campaign name",
			companySearch: "Search for company name",
			company: "Company",
			campaign: "Campaign",
			email: "Email",
			name: "Name",
			linkedin: "LinkedIn",
			add: "Add. Inf.",
		},
		errors: enErrors,
		mcpConsent: enMcpConsent,
		account: enAccount,
		notifications: {
			panel: {
				title: "Notifications",
				markAllRead: "Mark all read",
				tabs: {
					all: "All",
					unread: "Unread",
				},
				allCategories: "All categories",
				loading: "Loading…",
				empty: "No notifications",
				allCaughtUp: "You're all caught up!",
				previous: "← Previous",
				next: "Next →",
				pageOf: "Page {{page}} of {{totalPages}}",
			},
			item: {
				fallbackTitle: "Notification",
				aggregatedItems: "{{count}} items",
			},
			toast: {
				fallbackTitle: "Notification",
			},
			preferences: enNotificationPreferences,
		},
		job: {
			title: "Job Offers",
			jobTitle: "Job Offer Title",
			subtitle: "Here you can search for companies that published job offers",
			search: "Search for job offer",
			name: "Name",
			status: "Status",
			company: "Company",
			url: "URL of job offer",
			employmentType: "Employment Type",
			countOfResults: "Count of Results",
			create: {
				button: "Create New Job Offer Search",
				title: "Create New Job Offer Search",
			},
			delete: {
				title: "Delete Job Offer Search",
			},
			query: "Query",
			queryPlaceholder: "e.g. Sales Manager",
			scrapeLevel: "Scrape Level",
			getInfoAt: "Search for company-wide Info@ e-mail address",
			getEnrichment: "Complete enrichment to search for specific positions later on",
			getManagingDirector: "Search managing director from imprint etc",
			getPersonFromOffer: "Search for person from offer",
			tabs: {
				results: "Results",
				costs: "Costs",
			},
			email: "E-mail",
			phoneNumber: "Phone Number",
		},
		filteredNoResults: {
			message:
				"No matches for your search with the current filters. The active filters may be the reason — try searching without them.",
			searchWithoutFilters: "Search without filters",
		},
		basics: {
			activatingCampaign: "Activating campaign...",
			reachOut: "Reach out",
			expand: "Expand",
			collapse: "Collapse",
			emailStatus: "Email Status",
			error: "An error occured",
			toSearch: "Search",
			visitsPerDay: "Visits per day",
			connectionRequestsPerDay: "Connection requests per day",
			messagesPerDay: "Messages per day",
			hasLiSn: "Has Linkedin Sales Navigator",
			hasLinkedinPremium: "Has Linkedin Premium",
			hasAdminRights: "Has Company Page Admin Rights",
			linkedinStatus: "LinkedIn Status",
			linkedinAllowed: "Allow Connect Accounts",
			sendingLabel: "Sending user",
			nonSendingLabel: "Non-sending user",
			sendingLabelDesc:
				"Can connect 1× LinkedIn and 1× email address. Additional emails can be added separately.",
			nonSendingLabelDesc:
				"Can use the platform but cannot connect LinkedIn or email for outreach.",
			addToList: "Add to List",
			revertToBeChecked: "Revert to be reviewed",
			unarchiveToDraft: "Move to Drafts",
			unarchiveToReview: "Move to To be reviewed",
			selectColumns: "Select columns",
			wait: "Please wait",
			reset: "Reset",
			pleaseSelect: "Please select",
			noResults: "No results",
			noActiveCampaigns: "No valid campaigns",
			account: "Account",
			actions: "Actions",
			admin: "Admin",
			back: "Back",
			block: "block",
			cancel: "Cancel",
			change: "Edit",
			clickToChange: "Click to change",
			code: "Code",
			confirmationClose: "Are you sure you want to close the window?",
			confirm: "Confirm",
			confirmPassword: "Confirm Password",
			createSomething: "Create {{something}}",
			delete: "Delete",
			description: "Description",
			dragAndDropImage: "Drag & Drop",
			edit: "Edit",
			editSomething: "Edit {{something}}",
			email: "E-mail Address",
			enterSomething: "Enter {{something}}",
			firstName: "First Name",
			home: "Home",
			label: "Label",
			lastName: "Last Name",
			linkedinUrl: "LinkedIn URL",
			logout: "Logout",
			name: "Name",
			noData: "No Data",
			password: "Password",
			permissions: "Permissions",
			resetPassword: "Reset password",
			role: "Role",
			save: "Save",
			saveChanges: "Save changes",
			search: "Search {{something}}...",
			select: "Select",
			selectSomething: "Select {{something}}",
			setPassword: "Set password",
			status: "Status",
			termsAndConditions:
				"I have read the <link1>Terms and Conditions</link1> and the <link2>Privacy Policy</link2>",
			upload: "Upload",
			value: "Value",
			warning: "Attention",
			filter: "Filter",
			clear: "Reset All Filters",
			close: "Close",
			rows: "Rows",
			columns: "Columns",
			columnsShown: "Columns shown",
			export: "Export",
			next: "Next",
			previous: "Previous",
			preview: "Preview",
			addCriteria: "Add as source",
			copyCriteria: "Copy Criteria",
			archive: "Archive",
			unarchive: "Unarchive",
			campaign: "Campaign",
			enrich: "Enrich",
			blacklist: "Blacklist",
			addTo: "Add to",
			addToCrm: "Add to CRM",
			...enCrmAddToBasics,
			deleteMultipleConfirmation: "Are you sure you want to delete {{count}} items?",
			download: "Download",
			duplicate: "Duplicate",
			savedFilter: {
				title: "Saved Filters",
				save: "Save Filter",
				load: "Load Filter",
				delete: "Delete Filter",
				nameLabel: "Filter Name",
				namePlaceholder: "Enter a name for this filter",
				saveSuccess: "Filter saved successfully",
				deleteSuccess: "Filter deleted successfully",
				deleteConfirm: "Are you sure you want to delete this filter?",
				noSavedFilters: "No saved filters yet",
				selectFilter: "Select a saved filter",
			},
		},
		topupCredits: enTopupCredits,
		creditConfirm: enCreditConfirm,
		errorPages: enErrorPages,
		archivedAccount: enArchivedAccount,
		forgotPassword: enForgotPassword,
		setPassword: enSetPassword,
		verifyEmail: enVerifyEmail,
		inviteUser: enInviteUser,
		login: enLogin,
		privacyPolicy: {
			title: "Privacy Policy",
			lastUpdated: "Last updated: {{date}}",
			unavailable: "Privacy Policy is currently unavailable.",
			retry: "Retry",
			error: "Something went wrong while loading the Privacy Policy.",
		},
		modals: enModals,
		twoFA: enTwoFA,
		users: enUsers,
		userRoles: enUserRoles,
		liSn: enLiSn,
		support: enSupport,
		crmAddTo: enCrmAddTo,
		campaignsOverview: enCampaignsOverview,
		campaignLockExplainer: enCampaignLockExplainer,
		outreachActivation: enOutreachActivation,
		contacts: enContacts,
		featureOnboarding: {
			skipTour: "Skip tour",
			next: "Next",
			gotIt: "Got it",
			stepOf: "{{current}} / {{total}}",
		},
		calendarInvite: enCalendarInvite,
		pendingSchedules: enPendingSchedules,
		parallelAi: {
			addSource: "Add a source",
			sourceNameLabel: "Source name",
			searchQueryLabel: "Search term",
			modeSearch: "Search",
			modeMonitor: "Monitor",
			monitorQueryLabel: "What to monitor",
			monitorQueryPlaceholder: "e.g. funding or launch announcements from DE companies",
			frequencyLabel: "Check frequency",
			frequencyDaily: "Every day",
			frequencyWeekly: "Every week",
			monitorOngoingHint:
				"Monitors run continuously — add this source to an ongoing list so new events keep getting collected.",
			runNowHint: "Global admins only — triggering a run will likely cost money.",
		},
		companyEnrich: enCompanyEnrich,
		copywritingSettings: enCopywritingSettings,
		copywritingFrameworks: enCopywritingFrameworks,
	},
};
